import moment from 'moment';
import { HttpResponse } from '@/types/http';
import { UpdateOWASReportParamsDTO } from '@/core/dto/owas-report';
import { FormData } from '@/views/ListReport/Report/Owas/types';

interface UpdateOWASReportAttributes {
	status: string;
	message: string;
	data: {};
}

export class UpdateOWASReport {
	private readonly status: string;
	private readonly message: string;

	constructor({ status, message }: UpdateOWASReportAttributes) {
		this.status = status;
		this.message = message;
	}

	static toDTO(data: FormData): UpdateOWASReportParamsDTO {
		return {
			report_name: data.informations.report_name,
			organization_id: data.informations.organization_id,
			company_id: data.informations.company_id,
			sector_id: data.informations.sector_id,
			line_id: data.informations.line_id,
			workstation_id: data.informations.workstation_id,
			activity_id: data.informations.activity_id,
			evaluator_id: data.informations.evaluator_id,
			collection_date: moment(data.informations.collection_date).format(),
			analysis_date: moment(data.informations.analysis_date).format(),
			activity_description: data.informations.activity_description,
			men_exposed: data.informations.men_exposed,
			women_exposed: data.informations.women_exposed,
			other_exposed: data.informations.other_exposed,
			capture_interval_seconds: data.informations.capture_interval_seconds
		};
	}

	toTransform(): HttpResponse {
		return { status: this.status, message: this.message };
	}
}
